import { animateScroll } from 'react-scroll'

export const windowScrollToBottom = () => {
  setTimeout(() => {
    animateScroll.scrollToBottom()
  }, 100)
}
